import moment from "moment";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import { useGetQuoteRequestDetails } from "api/queries/quotes/useGetQuoteRequestDetails";

const formatDate = (date: string) => moment(date, "YYYY-MM-DD").format("DD MMMM YYYY, ");

function EditScheduleSidebar() {
  const id = useParams().id?.toUpperCase()!;
  const { data: shipmentDetailsData } = useGetQuoteRequestDetails({
    shipmentId: id,
  });

  const { schedule = {} } = shipmentDetailsData ?? {};
  const { pickup_date, pickup_time, pickup_city, pickup_country, stop1_date, stop1_time, stop1_city, stop1_country } =
    schedule;

  return (
    <div>
      <h6>
        <FormattedMessage id="tracking.components.editScheduleDialog.editSchedule" defaultMessage="Edit schedule" />
      </h6>
      <p className="mt-4 mb-2 font-b2">
        <FormattedMessage id="tracking.quotedPickup" defaultMessage="Quoted pickup" />
      </p>
      <p className="font-b3 text-secondary">
        {formatDate(pickup_date)} {pickup_time} <br />
        {[pickup_city, pickup_country].join(", ")}
      </p>

      <p className="mt-4 mb-2 font-b2">
        <FormattedMessage id="tracking.quotedDelivery" defaultMessage="Quoted delivery" />
      </p>
      <p className="mt-2 font-b3 text-secondary">
        {formatDate(stop1_date)} {stop1_time} <br />
        {[stop1_city, stop1_country].join(", ")}
      </p>
    </div>
  );
}

export default EditScheduleSidebar;
